
document.addEventListener('DOMContentLoaded', function() {
    const collectionContainer = document.querySelector('[js-collection-main-section]');

    
    function fetchNewCollection() {
        const collectionsList = collectionContainer.querySelectorAll('[js-sub-collection-item]')
        if(collectionsList) {
            collectionsList.forEach(cL => {
                cL.addEventListener('click', function(e) {
                    e.preventDefault()
                    const collectionHandle = e.target.dataset.collectionHandle
                    updateHistoryState(collectionHandle)
                    renderSection(collectionHandle)

                })
            })
        }
    }
    function getSectionsToRender() {
        return [
            {
                selector: "#product-grid"
            }
        ]
    }
    function renderSection(handle) {
        getSectionsToRender().forEach(section => {
            fetch(`/collections/${handle}`)
            .then(response=>response.text())
            .then(html=>{
                const doc = new DOMParser().parseFromString(html, "text/html");
                const productsGrid = doc.querySelector(`${section.selector}`)
                collectionContainer.querySelector(section.selector).innerHTML = productsGrid.innerHTML
                document.dispatchEvent(new CustomEvent("reindexGridElements:collection"))
            })
        })
    }
    function updateHistoryState(handle) {
        var newurl = `${window.location.protocol}//${window.location.host}/collections/${handle}`;
        window.history.pushState({
            path: newurl
        }, "", newurl)
    }

    function reindexGridElements() {  
        const productGridContainer = collectionContainer.querySelector('[js-first-grid-item]');
        const productsCount = parseInt(productGridContainer.getAttribute("data-products-count"));
        const collectionGrid = collectionContainer.querySelector("#product-grid");
        const allDesktopImageElements = Array.from(collectionContainer.querySelectorAll('[js-data-desktop-image-container]'));

        if(allDesktopImageElements) {
            if(window.innerWidth > 767) {
                if(productsCount <= 3) {
                    const desktopImageElement = allDesktopImageElements[0];
                    const currentElementIndex = Number(desktopImageElement.dataset.desktopImageIndex)
                    collectionGrid.appendChild(desktopImageElement)
                    desktopImageElement.classList.add("init");
                }else {
                    allDesktopImageElements.map((desktopImageElement, index) => {
                        const collectionGrids  = Array.from(collectionContainer.querySelectorAll('.grid__item'));
                        const collectionGridsLength = collectionGrids.length - 1;
                        const currentElementIndex = Number(desktopImageElement.dataset.desktopImageIndex)
                        if(collectionGridsLength > currentElementIndex && collectionGrid.querySelector(`.grid__item:nth-child(${currentElementIndex})`)) {
                          collectionGrid.insertBefore(desktopImageElement,collectionGrid.querySelector(`.grid__item:nth-child(${currentElementIndex})`))
                          desktopImageElement.classList.add("init");
                        }
                    })
                }
            } else {
                if(productsCount <= 3) {
                    const desktopImageElement = allDesktopImageElements[0];
                    const currentElementIndex = Number(desktopImageElement.dataset.desktopImageIndex);
                    collectionGrid.appendChild(desktopImageElement)
                    desktopImageElement.classList.add("init");
                }else {
                    allDesktopImageElements.map(desktopImageElement => {
                        const collectionGrids  = Array.from(collectionContainer.querySelectorAll('.grid__item'));
                        const collectionGridsLength = collectionGrids.length - 1;
                        const currentElementIndex = Number(desktopImageElement.dataset.mobileImageIndex)
                        if(collectionGridsLength > currentElementIndex && collectionGrid.querySelector(`.grid__item:nth-child(${currentElementIndex})`)) {
                          collectionGrid.insertBefore(desktopImageElement,collectionGrid.querySelector(`.grid__item:nth-child(${currentElementIndex})`))
                          desktopImageElement.classList.add("init");
                        }
                    })
                }
            }
        }
    }

    fetchNewCollection()

    reindexGridElements()
    document.addEventListener('reindexGridElements:collection', reindexGridElements)
})